<label [for]="for" [class.danger]="danger" [class.long-label]="isLongLabel">
  <span class="label-text" [class.uppercase]="uppercase" [title]="label">{{ label }}</span>
  <span *ngIf="tooltip" class="tooltip-icon">{{ !danger ? 'i' : '!' }}</span>
  <span *ngIf="tooltip" class="tooltip-text">{{ tooltip }}</span>
</label>